import { TypedMatNode } from "../_Base";
import { BaseTextureMapController, BooleanParamOptions, NodePathOptions } from "./_BaseTextureController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { MultiplyOperation, MixOperation, AddOperation } from "three";
import { CopType } from "../../../poly/registers/nodes/types/Cop";
var CombineOperation = /* @__PURE__ */ ((CombineOperation2) => {
  CombineOperation2["MULT"] = "mult";
  CombineOperation2["ADD"] = "add";
  CombineOperation2["MIX"] = "mix";
  return CombineOperation2;
})(CombineOperation || {});
const COMBINE_OPERATIONS = ["mult" /* MULT */, "add" /* ADD */, "mix" /* MIX */];
const OperationByName = {
  ["mult" /* MULT */]: MultiplyOperation,
  ["add" /* ADD */]: AddOperation,
  ["mix" /* MIX */]: MixOperation
};
export function EnvMapSimpleParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useEnvMap = ParamConfig.BOOLEAN(0, {
        separatorBefore: true,
        ...BooleanParamOptions(TextureEnvMapSimpleController)
      });
      this.envMap = ParamConfig.NODE_PATH("", NodePathOptions(TextureEnvMapSimpleController, "useEnvMap", { types: [CopType.CUBE_CAMERA] }));
      this.combine = ParamConfig.INTEGER(0, {
        visibleIf: { useEnvMap: 1 },
        menu: {
          entries: COMBINE_OPERATIONS.map((name, value) => {
            return { name, value };
          })
        }
      });
      this.reflectivity = ParamConfig.FLOAT(1, { visibleIf: { useEnvMap: 1 } });
      this.refractionRatio = ParamConfig.FLOAT(0.98, {
        range: [-1, 1],
        rangeLocked: [false, false],
        visibleIf: { useEnvMap: 1 }
      });
    }
  };
}
class TextureEnvMapSimpleParamsConfig extends EnvMapSimpleParamConfig(NodeParamsConfig) {
}
class TextureEnvMapSimpleMatNode extends TypedMatNode {
}
export class TextureEnvMapSimpleController extends BaseTextureMapController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
    this.add_hooks(this.node.p.useEnvMap, this.node.p.envMap);
  }
  async update() {
    this._update(this.node.material, "envMap", this.node.p.useEnvMap, this.node.p.envMap);
    const combine = OperationByName[COMBINE_OPERATIONS[this.node.pv.combine]];
    const mat = this.node.material;
    mat.combine = combine;
    mat.reflectivity = this.node.pv.reflectivity;
    mat.refractionRatio = this.node.pv.refractionRatio;
  }
  static async update(node) {
    node.controllers.envMap.update();
  }
}
